import { FilterOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Form, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { convertDataTypes } from '../../../library/helpers/index.js';
import ExecutiveEntitySelect from '../../inputs/ExecutiveEntitySelect.js';

const VatFilterForm = ({ children, data, ...otherProps }) => {
    const [form] = Form.useForm();

    const formattedValues = useMemo(() => {
        return convertDataTypes(data, {
            entity_id: v => (parseInt(v) || undefined),
            percentage: v => (v !== undefined && v !== null && v !== '' ? Number(v) : undefined),
        }) || {};
    }, [data]);

    useEffect(() => {
        form.setFieldsValue({
            entity_id: undefined,
            percentage: undefined,
            ...formattedValues,
        });
    }, [formattedValues, form]);

    const clearForm = () => {
        try {
            form.setFieldsValue({
                entity_id: null,
                percentage: null,
            });
            form.submit();
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <Form
            form={form}
            initialValues={formattedValues}
            layout="vertical"
            {...otherProps}
        >
            <Form.Item name="entity_id" label="Entity">
                <ExecutiveEntitySelect allowClear getPopupContainer={triggerNode => triggerNode.parentElement} />
            </Form.Item>

            <Form.Item name="percentage" label="Percentage (%)">
                <InputNumber
                    style={{ width: '100%' }}
                    placeholder="e.g. 21, 20, 9, 0"
                    min={0}
                    max={100}
                />
            </Form.Item>

            {children}

            <div className="actions filter-actions">
                <Button htmlType="submit" type="primary" icon={<FilterOutlined />}>Apply</Button>
                <Button onClick={clearForm} icon={<ReloadOutlined />}>Reset</Button>
            </div>
        </Form>
    );
};

VatFilterForm.propTypes = {
    children: PropTypes.node,
    data: PropTypes.object,
};

export default VatFilterForm;
